import { render, staticRenderFns } from "./ApplicationTransfer.vue?vue&type=template&id=5dbf0a9c&"
import script from "./ApplicationTransfer.vue?vue&type=script&lang=js&"
export * from "./ApplicationTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports